import React from "react";
import protfolio1 from "../assets/protfolio/protfolio1.png";
import webimage from "../assets/protfolio/1.svg";
import webimage2 from "../assets/protfolio/2.svg";
import webimage3 from "../assets/protfolio/3.svg";
import webimage4 from "../assets/protfolio/4.svg";
import juicedb from "../assets/protfolio/juicedb (1).png";
import alterscense from "../assets/protfolio/juicedb (2).png";
import addBaner from "../assets/protfolio/adbanner.png";
import tour from "../assets/protfolio/tour.png";

const Protfolio = () => {
  const protfolios = [
    {
      id: 1,
      src: juicedb,
      link: "https://altersense.com/",
      name: "company website",
    },
    {
      id: 2,
      src: addBaner,
      link: "https://courageous-squirrel-4a6f26.netlify.app/",
      name: "company website",
    },
    {
      id: 3,
      src: tour,
      link: "https://candid-salmiakki-fa606b.netlify.app/#",
      name: "company website",
    },
    {
      id: 4,
      src: juicedb,
      link: "https://altersense.com/erp/",
      name: "company website",
    },
  ];
  return (
    <div
      name="projects"
      className="bg-gradient-to-b from-black to-gray-800 w-full text-white h-screen"
    >
      <div className="max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full">
        <div className="pb-8 flex flex-row items-center space-x-3 text-xl">
          <p className="text-[#64ffda] font-bold">02.</p>
          <p className=" capitalize font-bold inline text-[#ccd6f6] font-serif">
            Some Things I’ve Built
          </p>
          <span class="w-72 border  border-cyan-900"></span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 px-12 sm:px-0">
          {protfolios.map(({ id, src, link, name }) => (
            <div
              key={id}
              className="flex flex-col cursor-pointer rounded-md relative"
            >
              <div className="bg-white shadow-md ">
                <a href={link}>
                  <img
                    className="rounded-md  h-[300px] w-full object-cover"
                    src={src}
                    alt=""
                  />
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Protfolio;
